import React from "react";
import ConnectorV1 from "./connector";
import Providers from "@/data-outreach/_core/forms/providers";
import data from './data';

function RvServiceV1(props) {
  return (
    <Providers {...props} data={data(props)}>
      <ConnectorV1 />
    </Providers>
  );
}

export default RvServiceV1;
